module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Session1.d6a0f84b.jpg";